
<div class="d-flex w-100 carte-produit-casino" :class="jel_getClassObject(content)">
  <template v-if="isVisible && produit">
    <CarteImageInfo
      v-if="isProduitLance"
      class="w-100"
      :class="{ produitDesactive: isProduitDesactive }"
      :content="getContentCarteImageInfo()"
      :afficherInfoSecondaire="afficherInfoSecondaire()"
    >
      <template #image>
        <div class="w-100 h-100" @click="jel_forcerClickHyperlien(refRedirection)">
          <MediaImageX3 :show="true" :content="contentMediaImageX3" />
          <span @click.capture="gaPreventClick">
            <b-link
              :ref="refRedirection"
              v-bind="jel_getLienBinding(mixinProduitCasino_getLienPageProduit())"
              class="d-none"
            >
              <!-- conserver pour accessibilité -->
              invisible
            </b-link>
          </span>
        </div>
      </template>

      <template #infoSecondaire>
        <CarteInfoSecondaireDesactivation
          v-if="isProduitDesactive || messageDesactivation"
          :content="{ texteDesactivation: messageDesactivation }"
        />
        <BanniereInfoLotProgressif
          v-else-if="isLotProgressif"
          ref="conteneurLotProgressif"
          :content="{
            produit: produit,
            isListeHorizontale: content.isListeHorizontale,
          }"
        />
        <BanniereInfoMASEnDirect
          v-else-if="isProduitMASEnDirect"
          :content="{
            produit: produit,
          }"
        />
      </template>
      <template #infoPrimaire>
        <CarteInfoPrimaireProduit
          :content="{
            produit: produitCarteInfoPrimaireProduit,
            isListeHorizontale: content.isListeHorizontale,
            cacherSurTitreCategorie: content.cacherSurTitreCategorie === 'true',
            gaEvent: gaEvent,
            gaCategorie: gaCategorie,
            gaTitreProduit: titreProduit,
            gaPosition: positionCarte,
          }"
        />
      </template>
    </CarteImageInfo>
  </template>
  <div
    v-else
    v-observe-visibility="{
      callback: visibilityChanged,
      once: true,
    }"
    class="chargement w-100 h-100"
  >
    <Carte :content="content" class="w-100">
      <b-skeleton-img no-aspect class="h-50"></b-skeleton-img>
      <div class="h-50">
        <span v-if="produit" class="text-truncate"
          >{{ mixinProduitCasino_getTitre(false) }}...</span
        >

        <div class="row">
          <div class="col-6">
            <b-skeleton width="85%"></b-skeleton>
            <b-skeleton width="55%"></b-skeleton>
            <b-skeleton width="70%"></b-skeleton>
            <b-skeleton width="85%"></b-skeleton>
          </div>
          <div class="col-6">
            <b-skeleton type="button"></b-skeleton>
          </div>
        </div>
      </div>
    </Carte>
  </div>
</div>
